import styled from 'styled-components';

export const Wrapper = styled.div`
  width: 100%;
  height: 100%;
  max-width: 800px;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 32px;
  padding-top: 24px;
  & > :first-child {
    margin-bottom: 0 !important;
  }
`;

export const TagSectionWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 12px;
  width: 100%;
  max-height: 400px;
  overflow-y: auto;
`;

export const SectionWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 12px;
  width: 100%;
  overflow-y: auto;
  height: 100%;
`;

export const TagItemWrapper = styled.div<{ $isSelected: boolean }>`
  display: flex;
  padding: 12px 16px;
  align-items: center;
  gap: 20px;
  width: 100%;
  border-radius: 8px;
  border: 1px solid
    ${({ theme, $isSelected }) => ($isSelected ? theme.colors.green6 : theme.colors.black4)};
  background: ${({ theme, $isSelected }) =>
    $isSelected ? theme.colors.green1 : theme.colors.white};
  cursor: pointer;

  .ant-radio-wrapper:hover .ant-radio-inner {
    border-color: ${({ theme }) => theme.colors.green6};
  }
  .ant-radio:hover .ant-radio-inner {
    border-color: ${({ theme }) => theme.colors.green6};
  }

  .ant-radio-checked .ant-radio-inner {
    border-color: ${({ theme }) => theme.colors.green6};
    background-color: transparent;
    border-width: 2px;
    :after {
      background-color: ${({ theme }) => theme.colors.green6};
    }
  }
`;

export const TitleWrapper = styled.div`
  font-size: 20px;
  font-weight: 600;
  line-height: 28px;
  letter-spacing: -0.2px;
`;

export const ListWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 12px;
  width: 100%;
  padding: 12px;
  border-radius: 8px;
  border: 1px solid ${({ theme }) => theme.colors.black4};
  max-height: 500px;
  overflow-y: auto;
`;

export const CourseItemWrapper = styled.div`
  display: flex;
  width: 100%;
  padding: 12px 16px;
  align-items: center;
  justify-content: space-between;
  gap: 20px;
  border-radius: 8px;
  border: 1px solid ${({ theme }) => theme.colors.black4};
  background: ${({ theme }) => theme.colors.white};
  cursor: pointer;

  &:hover {
    background: ${({ theme }) => theme.colors.green1};
    border: 1px solid ${({ theme }) => theme.colors.green6};
  }
`;

export const EmptyQuizzesWrapper = styled.div`
  display: flex;
  width: 100%;
  padding: 12px 16px;
  align-items: center;
  justify-content: center;
`;
